export default {"src":"/_next/static/media/menu.48a73272.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};